<div class="toggle-container">
    <div class="toggle-tab" [class.active]="viewMode === 'pres'" (click)="setView('pres')">
        Prescription
    </div>
    <div class="toggle-tab" [class.active]="viewMode === 'exec'" (click)="setView('exec')">
        Exécution
    </div>

</div>

<div class="content-container" *ngIf="selectedDemandeHospitalisation && itemBeneficiare">
    <app-form-pres-hospit (onUpdateParent)="onUpdateParent($event)" [selectedDemandeHospitalisation]="selectedDemandeHospitalisation" [itemBeneficiare]="itemBeneficiare" *ngIf="viewMode === 'pres'"></app-form-pres-hospit>
    <app-form-exec-hospit [selectedDemandeHospitalisation]="selectedDemandeHospitalisation" [itemBeneficiare]="itemBeneficiare" *ngIf="viewMode === 'exec'"></app-form-exec-hospit>
</div>